import { In } from 'typeorm'

import { Tutorial } from '../../../entities'

export const deleteTutorials = {
  async deleteTutorials(_: any, { ids }, context: ResolverContext) {
    const { tx, domain } = context.state
    await tx.getRepository(Tutorial).delete({
      domain: { id: domain.id },
      id: In(ids)
    })
    return true
  }
}
